export const ICON_CLASS_PLAY = "mdi-play";
export const ICON_CLASS_PAUSE = "mdi-pause";
export const ICON_CLASS_MUSIC_NOTE = "mdi-music-note";
export const CURSOR_ICON_ID = "cursorIcon";
export const CURSOR_ANIMATOR_ID = "cursorAnimator";
export const PLAY_PAUSE_BTN_ID = "playPauseBtn";
export const TRACK_TITLE_SPAN_ID = "trackTitle";